import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { KioskAuthContext } from "../ContextAPI/KisokContext";

export default function KioskProtectedRoute({ children }) {
  const { token } = useContext(KioskAuthContext);

  if (!token) return <Navigate to="/kisok-login" replace />;
  return children;
}
